import { ACCESS_TOKEN, getItem } from "local-storage";
import { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
import { getUserProfileData } from "services/apis/apis";
import useSWR from "swr";

export const useController = () => {
  const [currentTab, setCurrentTab] = useState("Chat");
  // const location = useLocation();
  // const navigate = useNavigate();
  // const queryParams = new URLSearchParams(location.search);
  // const [state] = useState(location.state);

  const handleChangeTab = (value: string) => {
    setCurrentTab(value);
  };

  const { data } = useSWR(["getUserProfileData"], async () => {
    const accessToken = getItem(ACCESS_TOKEN) || "";
    if (!accessToken) return;
    return getUserProfileData(accessToken);
  });

  return { currentTab, handleChangeTab, state: { id: data?.id } };
};
